export const _ADD               = "OV8GM+RuCDMS0JcRBuRK9g==";
export const _EDIT              = "x+/rYkUGjyOhDqxSaihPsg==";
export const _VIEW              = "oHkGXgwBotyoRM34snmSKQ==";
export const _DELETE            = "rcb60QGCCnLJjlp6Ew5C4Q==";
export const _RECOVER           = "X8op36Bk2TcoZjvs+26GOA==";
export const _LIST              = "LB7+HDI+QREsstC7W0gL/w==";
export const _TRASH             = "sKTVvDGE28kg8C1ih75YPQ==";